import { useSelector } from 'react-redux';
import { getThemeColor } from '../utils/themeUtils';

/**
 * Custom hook to get the current theme color from Redux state
 * @returns {string} The current theme color hex code
 */
const useThemeColor = () => {
  const appTheme = useSelector((state) => state.appSettings?.appTheme);
  return getThemeColor(appTheme);
};

export default useThemeColor;

